// extracted by mini-css-extract-plugin
module.exports = {"quantity":"ViewMyOrderButton_quantity__OmUzV","textWhite":"ViewMyOrderButton_textWhite__byFoq","orderButton":"ViewMyOrderButton_orderButton__Kgf_F"};